import { useEffect, useState } from "react";
import { useIntl } from "react-intl";

import { fetchTasOccurrence, fetchTasOccurrences } from "../api/tasOccurrence";
import { ITasOccurrence } from "../models/tasOccurrence";

export const useTasOccurrence = (chassis: string, tasNumber: string) => {
    const intl = useIntl();
    const [tasOccurrences, setTasOccurrences] = useState<ITasOccurrence[]>([]);
    const [tasOccurrence, setTasOccurrence] = useState<ITasOccurrence | null>(null);
    
    const [detailsLoading, setDetailsLoading] = useState<boolean>(false);
    const [tasOccurrenceDialog, setTasOccurrenceDialog] = useState<boolean>(false);

    const tasOccurrenceDetails: { label: string, value?: string }[] = [
        { label: intl.formatMessage({ id: "intl-msg:shared.occurrence.tas.number" }), value: tasOccurrence?.tasOccurrenceNumber },
        { label: intl.formatMessage({ id: "intl-msg:shared.occurrence.tas.status" }), value: tasOccurrence?.status },
        { label: intl.formatMessage({ id: "intl-msg:tas.occurrence.responsible" }), value: tasOccurrence?.responsible },
        { label: intl.formatMessage({ id: "intl-msg:shared.occurrence.tas.details" }), value: tasOccurrence?.details },
        { label: intl.formatMessage({ id: "intl-msg:support.subject" }), value: tasOccurrence?.tasSubject },
        { label: intl.formatMessage({ id: "intl-msg:support.constants.field.failureFrequency" }), value: tasOccurrence?.failureFrequency },
        { label: intl.formatMessage({ id: "intl-msg:support.constants.field.partOrComponentName" }), value: tasOccurrence?.partOrComponentName },
        { label: intl.formatMessage({ id: "intl-msg:support.constants.field.partNumber" }), value: tasOccurrence?.partNumber },
        { label: intl.formatMessage({ id: "intl-msg:shared.occurrence.tas.diagnosticAndResults" }), value: tasOccurrence?.diagnosticAndResults },
        { label: intl.formatMessage({ id: "intl-msg:support.tasAdditionalRequiredFields.customerComplaint" }), value: tasOccurrence?.customerComment },
        { label: intl.formatMessage({ id: "intl-msg:shared.occurrence.tas.diagnose" }), value: tasOccurrence?.diagnose },
        { label: intl.formatMessage({ id: "intl-msg:support.constants.field.problemDescription" }), value: tasOccurrence?.problemDescription },
        { label: intl.formatMessage({ id: "intl-msg:kanban.form.serviceChildForm.solutionProposed" }), value: tasOccurrence?.repair },
    ]

    useEffect(() => {
        if (chassis) getTasOccurrences();
        else setTasOccurrences([]);
    }, [chassis]);

    useEffect(() => {
        if (chassis && tasNumber) getTasOccurrence();
        else setTasOccurrence(null);
    }, [tasOccurrences, tasNumber]);

    const getTasOccurrences = async () => {
        try {
            const data = await fetchTasOccurrences(chassis, intl);
            setTasOccurrences(data);
        } catch {
            setTasOccurrences([]);
        }
    }

    const getTasOccurrence = async () => {
        setDetailsLoading(true);
        try {
            const data = await fetchTasOccurrence(chassis, tasNumber, intl);
            setTasOccurrence(data || null);
        } catch (error) {
            console.error('Error fetching tas occurrence:', error);
        } finally {
            setDetailsLoading(false);
        }
    }

    return {
        detailsLoading,
        tasOccurrence,
        tasOccurrences,
        tasOccurrenceDetails,
        tasOccurrenceDialog,
        setTasOccurrenceDialog,
    };
};